<script setup lang="ts">
import { useListGridViewPreference } from '~/composables/list-grid-view-preference';
import type { Collection } from '~/utilities/pyscript-api-models';
import CollectionCatalogList from '~/components/collections/CollectionCatalogList.vue';
import CollectionCatalogGrid from '~/components/collections/CollectionCatalogGrid.vue';

defineProps<{
  collections: Collection[];
}>();

const { savedView } = useListGridViewPreference();
</script>

<template>
  <CollectionCatalogGrid v-if="savedView === 'grid'" :collections="collections" />

  <CollectionCatalogList v-else :collection-list="collections" />
</template>
